import React from "react";
// import CEMS from "../../cems/CemsApp";
// import H2 from "../../h2/H2App";
import VUP from "../../vup/VUPApp";
import FXMS from "../../fxms/FxmsApp";
import TEST from "../../vup/TestApp";

const FxBaseService = () => {
  const { REACT_APP_BASE_SERVICE } = process.env;

  const selectService = () => {
    switch (REACT_APP_BASE_SERVICE) {
      // case "CEMS":
      //   return <CEMS />;
      // case "H2":
      //   return <H2 />;
      case "FXMS":
        return <FXMS />;
      case "TEST":
        return <TEST />;
      case "VUP":
        return <VUP />;
      default:
        return <VUP />;
    }
  };

  return REACT_APP_BASE_SERVICE ? selectService() : "";
};

export default FxBaseService;
